export const navLinks = [
  { text: 'Home', to: '/' },
  { text: 'About Us', to: '/about' },
  { text: 'Products', to: '/products' },
  { text: 'Events', to: '/events' },
  { text: 'Infrastructure', to: '/infrastructure' },
  { text: 'Private Labeling', to: '/private-labeling' },
  { text: 'Contacts Us', to: '/contacts' },
];

export const companyName = <span style={{ fontFamily: `'Libre Baskerville', serif'`, fontWeight: 'bold' }}>MRMC Foods Pvt. Ltd</span>;

export const testimonialsData = [
  {
    src: 'images/test1.jpg',
    name: 'Arjun Rathore',
    description: `MRMC FOODS has been the cornerstone of our business success. Their wide range of basmati rice varieties reflects the rich tapestry of Indian culture and tradition. The quality and consistency of their products are unparalleled, making them the go-to choice for discerning consumers like us. We are proud to be
        associated with MRMC and look forward to many more years of fruitful collaboration`
  },
  {
    src: 'images/test2.jpg',
    name: 'Meera Kapoor',
    description: `MRMC FOODS has been our culinary lifeline. Their unwavering dedication to quality basmati rice varieties has elevated our dishes to new heights. As a chef, sourcing reliable ingredients is crucial, and MRMC consistently delivers. Their rice transports our customers to the heart of India with every bite. We're grateful for their partnership`
  },
  {
    src: 'images/test3.jpg',
    name: 'Neha Singh',
    description: `MRMC FOODS is our preferred supplier for a reason. Their quality basmati rice varieties and attention to detail are unmatched. Whether it's 1121 SELA or SUGANDHA STEAM, MRMC consistently delivers on flavor and texture. We're thrilled with our partnership`
  },
  {
    src: 'images/test1.jpg',
    name: 'Arjun Rathore',
    description: `MRMC FOODS has been the cornerstone of our business success. Their wide range of basmati rice varieties reflects the rich tapestry of Indian culture and tradition. The quality and consistency of their products are unparalleled, making them the go-to choice for discerning consumers like us. We are proud to be
        associated with MRMC and look forward to many more years of fruitful collaboration`
  },
  {
    src: 'images/test2.jpg',
    name: 'Meera Kapoor',
    description: `MRMC FOODS has been our culinary lifeline. Their unwavering dedication to quality basmati rice varieties has elevated our dishes to new heights. As a chef, sourcing reliable ingredients is crucial, and MRMC consistently delivers. Their rice transports our customers to the heart of India with every bite. We're grateful for their partnership`
  },
  {
    src: 'images/test3.jpg',
    name: 'Neha Singh',
    description: `MRMC FOODS is our preferred supplier for a reason. Their quality basmati rice varieties and attention to detail are unmatched. Whether it's 1121 SELA or SUGANDHA STEAM, MRMC consistently delivers on flavor and texture. We're thrilled with our partnership`
  },
]


export const products = [
  {
    name: 'Royal Basmati Rice',
    category: 'Yashas',
    imageUrl: require('./assets/images/products/Yashas6.png')
  },
  {
    name: 'Special Basmati Rice',
    category: 'Yashas',
    imageUrl: require('./assets/images/products/Yashas1.png')
  },
  {
    name: 'Evergreen Basmati Rice',
    category: 'Yashas',
    imageUrl: require('./assets/images/products/Yashas2.png')
  },
  {
    name: 'Royal Basmati Rice',
    category: 'Yashas',
    imageUrl: require('./assets/images/products/Yashas3.png')
  },
  {
    name: 'Popular Basmati Rice',
    category: 'Yashas',
    imageUrl: require('./assets/images/products/Yashas4.png')
  },
  {
    name: 'Harroz Basmati Rice',
    category: 'Yashas',
    imageUrl: require('./assets/images/products/Yashas5.png')
  },
  {
    name: 'Evergreen Basmati Rice',
    category: 'Hunar',
    imageUrl: require('./assets/images/products/Hunar1.png'),
  },
  {
    name: 'Popular Basmati Rice',
    category: 'Hunar',
    imageUrl: require('./assets/images/products/Hunar2.png'),
  },
  {
    name: 'Harroz Basmati Rice',
    category: 'Hunar',
    imageUrl: require('./assets/images/products/Hunar3.png'),
  },
  {
    name: 'Special Basmati Rice',
    category: 'Hunar',
    imageUrl: require('./assets/images/products/Hunar4.png'),
  },
  {
    name: 'Royal Basmati Rice',
    category: 'Hunar',
    imageUrl: require('./assets/images/products/Hunar5.png'),
  }
];

export const carouselItemsforMobile = [
  {
    src: require('./assets/images/Carousel/banner-for-mobile.jpg'),
    alt: "Carousel-Image"
  },
  {
    src: require('./assets/images/Carousel/banner-for-mobile1.png'),
    alt: "Carousel-Image"
  },
  {
    src: require('./assets/images/Carousel/banner-for-mobile2.jpg'),
    alt: "Carousel-Image"
  },
  {
    src: require('./assets/images/Carousel/banner-for-mobile3.png'),
    alt: "Carousel-Image"
  },
]

export const carouselItemsforDesktop = [
  {
    src: require('./assets/images/Carousel/Carousel-Image.jpg'),
    alt: "Carousel-Image"
  },
  {
    src: require('./assets/images/Carousel/Carousel-Image1.png'),
    alt: "Carousel-Image"
  },
  {
    src: require('./assets/images/Carousel/Carousel-Image2.jpg'),
    alt: "Carousel-Image"
  },
  {
    src: require('./assets/images/Carousel/Carousel-Image3.png'),
    alt: "Carousel-Image"
  },
]

export const googleMap = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3522340.7628904274!2d72.28670385887821!3d30.442146502039133!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3919e42c24c6d4ff%3A0xd515ed799759aed1!2sMRMC%20Foods%20Pvt.%20Ltd.%20-%20Rice%20Mill%20in%20Ferozpur!5e0!3m2!1sen!2sin!4v1712822594332!5m2!1sen!2sin";



export const ProductsSlider = [
  {
    src: require('./assets/images/slider1.png'),
    alt: "Product 1"
  },
  {
    src: require('./assets/images/slider2.png'),
    alt: "Product 2"
  },
  {
    src: require('./assets/images/slider3.png'),
    alt: "Product 3"
  },
  {
    src: require('./assets/images/slider4.png'),
    alt: "Product 4"
  },
  {
    src: require('./assets/images/slider5.png'),
    alt: "Product 5"
  },

];

export const WhyChooseUsPrivateLabeling = [
  {}
];

export const processStepsData = [
  { title: "Farming", image: require('./assets/images/OurProcess/Farming.png') },
  { title: "Procurement", image: require('./assets/images/OurProcess/Procurement.png') },
  { title: "Milling", image: require('./assets/images/OurProcess/Milling.png') },
  { title: "Distribution", image: require('./assets/images/OurProcess/Distribution.png') },
  { title: "Customer", image: require('./assets/images/OurProcess/Customer.png') }
];


export const eventGroups = [
  {
    title: 'Gulfood 2025',
    events: [
      {
        image: require('./assets/images/events/2025/evt-1.png'),
        alt: 'Event 1',
        sm: 12,
        md: 5,
        lg: 5,
      },
      {
        image: require('./assets/images/events/2025/evt-2.png'),
        alt: 'Event 2',
        sm: 12,
        md: 7,
        lg: 7,
      },
      {
        image: require('./assets/images/events/2025/evt-3.png'),
        alt: 'Event 3',
        sm: 12,
        md: 4,
        lg: 4,
      },
      {
        image: require('./assets/images/events/2025/evt-4.png'),
        alt: 'Event 4',
        sm: 12,
        md: 4,
        lg: 4,
      },
      {
        image: require('./assets/images/events/2025/evt-5.png'),
        alt: 'Event 5',
        sm: 12,
        md: 4,
        lg: 4,
      },
      {
        image: require('./assets/images/events/2025/evt-6.png'),
        alt: 'Event 6',
        sm: 12,
        md: 5,
        lg: 5,
      },
      {
        image: require('./assets/images/events/2025/evt-7.png'),
        alt: 'Event 7',
        sm: 12,
        md: 7,
        lg: 7,
      },
      {
        image: require('./assets/images/events/2025/evt-8.png'),
        alt: 'Event 8',
        sm: 12,
        md: 4,
        lg: 4,
      },
      {
        image: require('./assets/images/events/2025/evt-9.png'),
        alt: 'Event 9',
        sm: 12,
        md: 4,
        lg: 4,
      },
      {
        image: require('./assets/images/events/2025/evt-10.png'),
        alt: 'Event 10',
        sm: 12,
        md: 4,
        lg: 4,
      },
      {
        image: require('./assets/images/events/2025/evt-11.png'),
        alt: 'Event 11',
        sm: 12,
        md: 5,
        lg: 5,
      },
      {
        image: require('./assets/images/events/2025/evt-12.png'),
        alt: 'Event 12',
        sm: 12,
        md: 7,
        lg: 7,
      },
      {
        image: require('./assets/images/events/2025/evt-13.png'),
        alt: 'Event 13',
        sm: 12,
        md: 6,
        lg: 6,
      },
      {
        image: require('./assets/images/events/2025/evt-14.png'),
        alt: 'Event 14',
        sm: 12,
        md: 6,
        lg: 6,
      },
    ]
  },
  {
    title: 'Saudi Food Show 2024',
    events: [
      {
        image: require('./assets/images/events/ind/ind-1.png'),
        alt: 'Event 13',
        sm: 12,
        md: 5,
        lg: 5,
      },
      {
        image: require('./assets/images/events/ind/ind-2.png'),
        alt: 'Event 14',
        sm: 12,
        md: 7,
        lg: 7,
      },
      {
        image: require('./assets/images/events/ind/ind-3.png'),
        alt: 'Event 15',
        sm: 12,
        md: 4,
        lg: 4,
      },
      {
        image: require('./assets/images/events/ind/ind-4.png'),
        alt: 'Event 16',
        sm: 12,
        md: 4,
        lg: 4,
      },
      {
        image: require('./assets/images/events/ind/ind-5.png'),
        alt: 'Event 17',
        sm: 12,
        md: 4,
        lg: 4,
      },
      {
        image: require('./assets/images/events/ind/ind-6.png'),
        alt: 'Event 18',
        sm: 12,
        md: 5,
        lg: 5,
      },
      {
        image: require('./assets/images/events/ind/ind-7.png'),
        alt: 'Event 19',
        sm: 12,
        md: 7,
        lg: 7,
      },
      {
        image: require('./assets/images/events/ind/ind-8.png'),
        alt: 'Event 20',
        sm: 12,
        md: 4,
        lg: 4,
      },
      {
        image: require('./assets/images/events/ind/ind-9.png'),
        alt: 'Event 21',
        sm: 12,
        md: 8,
        lg: 8,
      },
      {
        image: require('./assets/images/events/ind/ind-10.png'),
        alt: 'Event 22',
        sm: 12,
        md: 5,
        lg: 5,
      },
      {
        image: require('./assets/images/events/ind/ind-11.png'),
        alt: 'Event 23',
        sm: 12,
        md: 7,
        lg: 7,
      },
      {
        image: require('./assets/images/events/ind/ind-12.png'),
        alt: 'Event 24',
        sm: 12,
        md: 4,
        lg: 4,
      },
      {
        image: require('./assets/images/events/ind/ind-13.png'),
        alt: 'Event 25',
        sm: 12,
        md: 4,
        lg: 4,
      },
      {
        image: require('./assets/images/events/ind/ind-14.png'),
        alt: 'Event 26',
        sm: 12,
        md: 4,
        lg: 4,
      },
      {
        image: require('./assets/images/events/ind/ind-15.png'),
        alt: 'Event 27',
        sm: 12,
        md: 5,
        lg: 5,
      },
      {
        image: require('./assets/images/events/ind/ind-16.png'),
        alt: 'Event 28',
        sm: 12,
        md: 7,
        lg: 7,
      },
      {
        image: require('./assets/images/events/ind/ind-17.png'),
        alt: 'Event 29',
        sm: 12,
        md: 5,
        lg: 5,
      },
      {
        image: require('./assets/images/events/ind/ind-18.png'),
        alt: 'Event 30',
        sm: 12,
        md: 7,
        lg: 7,
      },
    ],
  },
  {
    title: 'agro pack iraq ',
    events: [
      {
        image: require('./assets/images/events/event-1.png'),
        alt: 'Event 1',
        sm: 12,
        md: 12,
        lg: 12,
      },
      {
        image: require('./assets/images/events/event-2.png'),
        alt: 'Event 2',
        sm: 12,
        md: 12,
        lg: 12,
      },
      {
        image: require('./assets/images/events/event-3.png'),
        alt: 'Event 3',
        sm: 8,
        md: 8,
        lg: 8,
      },
      {
        image: require('./assets/images/events/event-4.png'),
        alt: 'Event 4',
        sm: 4,
        md: 4,
        lg: 4,
      },
    ],
  },
  {
    title: 'Delhi Stall',
    subTitle: 'World Food India 2023',
    events: [
      {
        image: require('./assets/images/events/event-5.png'),
        alt: 'Event 5',
        sm: 4,
        md: 4,
        lg: 4,
      },
      {
        image: require('./assets/images/events/event-6.png'),
        alt: 'Event 6',
        sm: 4,
        md: 4,
        lg: 4,
      },
      {
        image: require('./assets/images/events/event-7.png'),
        alt: 'Event 7',
        sm: 4,
        md: 4,
        lg: 4,
      },
      {
        image: require('./assets/images/events/event-8.png'),
        alt: 'Event 8',
        sm: 12,
        md: 12,
        lg: 12,
      },
    ],
  },
  {
    title: 'independence day',
    events: [
      {
        image: require('./assets/images/events/event-9.png'),
        alt: 'Event 9',
        sm: 12,
        md: 4,
        lg: 4,
      },
      {
        image: require('./assets/images/events/event-10.png'),
        alt: 'Event 10',
        sm: 12,
        md: 8,
        lg: 8,
      },
      {
        image: require('./assets/images/events/event-11.png'),
        alt: 'Event 11',
        sm: 12,
        md: 8,
        lg: 8,
      },
      {
        image: require('./assets/images/events/event-12.png'),
        alt: 'Event 12',
        sm: 12,
        md: 4,
        lg: 4,
      }
    ],
  },
];